"use strict";

exports.__esModule = true;
exports.Accordian = Accordian;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _Theme = require("../../Theme");
var _ListView = require("../ListView");
var _excluded = ["items", "isItemOpen", "getKey", "renderItem", "toggleItemOpen", "renderItemContent", "itemHeight", "itemWidth", "expandedViewHeight", "expandedViewMaxHeight"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var AccordianItem = (0, _styledComponents["default"])(_ListView.ListItemViewButton).withConfig({
  displayName: "Accordian__AccordianItem",
  componentId: "sc-71kliw-0"
})(["width:100%;height:", ";display:flex;border:solid 1px ", ";&:focus{outline:none;}"], function (props) {
  return props.height || "48px";
}, (0, _Theme.selectable)("ListItemBorderColor"));
var AccordianExpandedView = _styledComponents["default"].div.withConfig({
  displayName: "Accordian__AccordianExpandedView",
  componentId: "sc-71kliw-1"
})(["display:", ";height:", ";overflow:auto;"], function (props) {
  return props.isOpen ? "block" : "hidden";
}, function (props) {
  return props.isOpen ? props.height : "0px";
});
function Accordian(props) {
  var items = props.items,
    isItemOpen = props.isItemOpen,
    getKey = props.getKey,
    renderItem = props.renderItem,
    toggleItemOpen = props.toggleItemOpen,
    renderItemContent = props.renderItemContent,
    itemHeight = props.itemHeight,
    itemWidth = props.itemWidth,
    expandedViewHeight = props.expandedViewHeight,
    expandedViewMaxHeight = props.expandedViewMaxHeight,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      "data-testid": "AccordianItem",
      key: getKey(item)
    }, extra), /*#__PURE__*/_react["default"].createElement(AccordianItem, {
      "data-testid": "AccordianItemHeader-" + getKey(item),
      onClick: function onClick() {
        return toggleItemOpen(item);
      },
      height: itemHeight,
      width: itemWidth
    }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: isItemOpen(item) ? _icons.IconNames.CHEVRON_DOWN : _icons.IconNames.CHEVRON_RIGHT,
      style: {
        marginRight: "5px"
      }
    }), renderItem(item)), /*#__PURE__*/_react["default"].createElement(AccordianExpandedView, {
      "data-testid": "AccordianItemContent-" + getKey(item),
      isOpen: isItemOpen(item),
      height: expandedViewHeight,
      maxHeight: expandedViewMaxHeight,
      transitionDuration: 10,
      keepChildrenMounted: true
    }, renderItemContent(item)));
  }));
}